import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const ManagementOperationalAudits = () => {
  const serviceData = {
    title: "Management & Operational Audits",
    heading: "Management & Operational Audits",
    image: subTopicImages["Management & Operational Audits"],
    intro: "Improving efficiency, controls and business performance",
    description: [
      "A management or operational audit goes beyond financial records — evaluating how effectively the organisation runs. These audits review processes, resource utilisation, risk management controls and efficiency gaps.",
      "At V DOOGAR AND ASSOCIATES, we perform structured operational reviews to help management strengthen internal systems, improve productivity, reduce leakages and build a strong governance culture.",
    ],
    services: [
      {
        title: "Operational Audits",
        text: "Assessment of business processes, workflows and systems to evaluate:",
        list: [
          "efficiency",
          "internal controls",
          "risk exposure",
          "policy adherence",
        ],
        extraInfo: "And identify improvement areas across operations.",
      },
      {
        title: "Risk Assessments",
        text: "Independent evaluation of business risks — financial, operational and compliance-related — with:",
        list: ["clear mitigation recommendations"],
        extraInfo:
          "Helping management anticipate and manage potential threats.",
      },
      {
        title: "Internal Control Reviews",
        text: "Detailed review of existing control mechanisms and governance frameworks to ensure:",
        list: ["reliability", "consistency", "risk prevention"],
        extraInfo: "Strengthening the overall control environment.",
      },
    ],
    benefitsIntro: "Benefits of this service:",
    benefits: [
      "Improved process efficiency",
      "Proactive risk identification",
      "Stronger internal controls",
      "Better operational discipline",
      "Action-oriented recommendations",
    ],
    research:
      "Our approach blends risk-based auditing with practical business insight, enabling leadership to make informed decisions and strengthen organisational resilience.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default ManagementOperationalAudits;
